module.exports = __webpack_public_path__ + "static/media/prv9.2772b8a3.jpg";